import React from "react";

import { StyledSVG } from "../StyledIcon";

export const CoreConceptsIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M11.8284 11.8284C12.4828 11.1741 12.89 10.313 12.9807 9.39207C13.0714 8.4711 12.84 7.54718 12.3259 6.77772C11.8117 6.00826 11.0467 5.44087 10.1611 5.17224C9.27557 4.9036 8.32424 4.95034 7.46927 5.30448C6.61429 5.65863 5.90856 6.29826 5.47232 7.11441C5.03608 7.93056 4.89632 8.87272 5.07686 9.78036C5.2574 10.688 5.74707 11.505 6.46243 12.092C7.17779 12.6791 8.07458 13 9 13"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13L9 17"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2L9 1"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.70711 3.70711L3 3"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9999 3.70711L14.707 3"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 9L1 9"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 9L16 9"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
